export default [
    { value: "always_enable", label: "Always enable" },
    { value: "always_pause", label: "Always paused" },
    { value: "manually_modified", label: "Manually modified ext.", isdisabled: true },
    { value: "rule_7_days", label: "Rule 7 days availability" }
]